//import { Icon } from "antd";
import React, { useEffect, useRef } from "react";
import { getIntroduction } from "../../../../api/courses";
import { MatApoyo } from "../Generals";
//import { useSelector } from "react-redux";
//import { nombreOPL} from "../../../Generals/autoridadesElectorales";

export default function Lesson1({ data, objEntidad, origen }) {

  //const { idEntidad, entidad } = useSelector((state) => state.entidad);


  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {

    window.scrollTo(0, 0); // para posicionar el scroll al inicio

    getIntroduction().then((res) => {
      //isMounted.current && setIntro(res.data);
    }).catch((e) => {
      console.log(e);
    });

  }, []);

  //función que obtiene los datos de la entidad dependiendo si se visualiza la lección desde el curso o desde materiales de capacitación
  /*const getDataEntidad = () =>{
    const dataEntidad = origen === 1 ? objEntidad : {idEntidad: idEntidad, entidad: entidad};
    return dataEntidad
  }*/

  return (
    <>
      <p>
        El INE te da una cordial bienvenida y agradece tu participación en el curso La observación electoral. 
        Proceso Electoral Extraordinario del Poder Judicial de la Federación 2024-2025.
      </p>
      <p>  
        La observación electoral es una herramienta que permite a las ciudadanas y los ciudadanos mexicanos 
        participar activamente en la vigilancia del proceso electoral extraordinario del Poder Judicial de la 
        Federación (PJF), y asegurarse de que cada etapa, desde el inicio hasta la conclusión, se realice con 
        apego a los principios democráticos.
      </p>

       <p>{data && data.indexOf(1) &&<MatApoyo array={[data[1]]} />}</p>
       {/*<img src={ `data:image/jpeg;base64,${data[1].url}`} alt="img" className="imagen" /> <br/>Si se desesa mostrar la imagen se usa este codigo*/}

      <div className="texto_parrafo">
        <p>
          Para desempeñarte como observadora u observador electoral (OE) durante el Proceso Electoral Extraordinario 
          del PJF 2024-2025, es indispensable cumplir con ciertos requisitos establecidos por la ley, los cuales aseguran 
          que quienes participen en esta labor cuenten con la capacidad y el compromiso necesarios para observar de 
          manera objetiva e imparcial el desarrollo de las elecciones desde su inicio hasta su conclusión.
        </p>
        <p>
          Para obtener la acreditación y poder ser OE, debes cumplir con determinados <b>requisitos</b>, identifícalos en la 
          siguiente imagen:
        </p>
        
        <p>{data && data.indexOf(2) &&<MatApoyo array={[data[2]]} />}</p>
       {/*<img src={ `data:image/jpeg;base64,${data[2].url}`} alt="img" className="imagen" /> <br/>Si se desesa mostrar la imagen se usa este codigo*/}

        <p> 
          Debes tomar en cuenta que la labor que realizan las observadoras y los observadores electorales se enmarca 
          en una serie de principios fundamentales que permiten mantener la legitimidad y la confianza en el sistema 
          democrático.
        </p>

        <p>
          Los <b>principios de actuación</b> que te guiarán durante el ejercicio de tus funciones se detallan en la siguiente 
          imagen.
        </p>

        <p>{data && data.indexOf(3) &&<MatApoyo array={[data[3]]} />}</p>
        {/*<img src={ `data:image/jpeg;base64,${data[3].url}`} alt="img" className="imagen" /> <br/>Si se desesa mostrar la imagen se usa este codigo*/}

        <p>
          Una vez que obtengas tu acreditación, cuentas con <b>derechos que sirven de apoyo para poder llevar a cabo</b> tu labor 
          de vigilancia durante el proceso electoral extraordinario, la cual garantiza la transparencia y legalidad de las 
          elecciones. Al mismo tiempo, tu participación implica el cumplimiento de <b>obligaciones</b>, que aseguran que tu desempeño 
          se apegue a los principios de imparcialidad y objetividad. 
        </p>

        <p>{data && data.indexOf(4) &&<MatApoyo array={[data[4]]} />}</p>
        {/*<img src={ `data:image/jpeg;base64,${data[4].url}`} alt="img" className="imagen" /> <br/>Si se desesa mostrar la imagen se usa este codigo*/}


        {/*<ol className="listCirculo">
          <li>Nombre de la o el ciudadano.</li>
          <li>Nombre de la organización a la que pertenece, en su caso.</li>
          <li>Elección que observó.</li>
          <li>Entidad federativa, distrito local o federal, o municipio en el cual participó.</li>
          <li>Etapas del proceso electoral en las que participó.</li>
          <li>A cuántas y cuáles casillas acudió.</li>
          <li>Descripción de las actividades realizadas.</li>
        </ol><br/>*/}

        <p>
          Prueba tus conocimientos realizando la siguiente actividad interactiva. Explora las opciones, responde las 
          preguntas y verifica tus resultados para reforzar lo aprendido. ¡Puedes intentarlo tantas veces como desees!
        </p>

        <p>{data && data.indexOf(5) &&<MatApoyo array={[data[5]]} />}</p>

        <p>
          Revisa la presentación, en la que encontrarás un resumen claro y conciso del tema. Este material te será de 
          gran ayuda para complementar tu aprendizaje y reforzar los conceptos clave.
        </p>

        <p>{data && data.indexOf(6) &&<MatApoyo array={[data[6]]} />}</p>

        <p style={{textAlign: 'start'}}>
          Para profundizar tus conocimientos sobre la observación electoral, revisa el 
          <div className="textoResaltado2" style={{display: "inline"}}> tema 1 </div>  de la 
          &nbsp;{data && data.indexOf(7) && <MatApoyo array={[data[7]]} tipo={1}/>} que está disponible 
          en los materiales de consulta de este curso.
        </p>

        <p>
          ¡Muy bien! Ahora que tienes un panorama general de la observación electoral y los principios que la rigen, 
          realiza la actividad de autoevaluación para reforzar tu aprendizaje, después podrás continuar con la siguiente 
          lección.
        </p>
      </div>
    </>
  );
}
